import React from 'react';
import { connect } from 'react-redux';
import { nextTask } from '../study-logic/study-redux-slice'; // Adjust the import path as needed
import { Button, Checkbox, FormControlLabel } from '@mui/material';
import ConsentForm from './ConsentForm'; // Corrected import statement

class Consent extends React.Component {
    constructor(props) {
        super(props);
        this.state = { consented: false };
        this.handleChange = this.handleChange.bind(this);
        this.submit = this.submit.bind(this);
    }

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    handleChange(event) {
        this.setState({ consented: event.target.checked });
    }

    submit() {
        if (this.state.consented) {
            this.props.nextTask({});
        } else {
            // Handle the case when consent is not given
        }
    }

    render() {
    const { consented } = this.state;
    return (
        <div>
            <ConsentForm />

            {/* Container for centering the FormControlLabel */}
            <div style={{ display: 'flex', justifyContent: 'center', marginTop: '0px' }}>
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={consented}
                            onChange={this.handleChange}
                        />
                    }
                    label="I consent to participate in this study"
                />
            </div>

            {/* Container for centering the button */}
            <div style={{ display: 'flex', justifyContent: 'center', marginTop: '0px' , marginBottom: '50px'  }}>
                <Button
                    variant={consented ? 'contained' : 'text'}
                    color={'success'}
                    onClick={this.submit}
                    disabled={!consented}
                >
                    Start
                </Button>
            </div>
        </div>
    );
}
}

const mapDispatchToProps = { nextTask };

export default connect(null, mapDispatchToProps)(Consent);
